import requests from "../Locality/Service/httpService";

/** Fee collection API (/api/feecollection). The school comes from the login token. */
const FeeCollectionService = {
  searchStudents: (q, filters = {}) =>
    requests.get("/feecollection/students", { params: { q, classId: filters.classId || undefined, sectionId: filters.sectionId || undefined } }),
  studentOptions: (studentId) => requests.get(`/feecollection/students/${studentId}/options`),
  collectOffline: (body) => requests.post("/feecollection/offline", body),
  payOnline: (body) => requests.post("/feecollection/online", body),
  receipts: (params) => requests.get("/feecollection/receipts", { params }),
  receipt: (id) => requests.get(`/feecollection/receipts/${id}`),
  setChequeStatus: (id, status) => requests.put(`/feecollection/receipts/${id}/cheque-status`, { status }),
  dayReport: (date) => requests.get("/feecollection/day-report", { params: { date } }),
};

export default FeeCollectionService;

export const OFFLINE_MODES = ["Cash", "Card", "Net banking", "Cheque"];
export const ONLINE_MODES = ["UPI", "Credit card", "Debit card", "Net banking"];

export const money = (n) =>
  `₹${(Number(n) || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

/** dd/mm/yyyy from YYYY-MM-DD (or a date). */
export const dmy = (value) => {
  if (!value) return "";
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString("en-GB");
};

export const todayYmd = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

/* Indian-style amount in words (same rules as the backend's utils/amountInWords.js). */
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
  "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
const belowHundred = (n) => (n < 20 ? ONES[n] : `${TENS[Math.floor(n / 10)]} ${ONES[n % 10]}`.trim());
const belowThousand = (n) => (n >= 100 ? `${ONES[Math.floor(n / 100)]} Hundred ${belowHundred(n % 100)}`.trim() : belowHundred(n));
const wholeInWords = (n) => {
  if (n === 0) return "Zero";
  const parts = [];
  [[10000000, "Crore"], [100000, "Lakh"], [1000, "Thousand"]].forEach(([size, name]) => {
    if (n >= size) {
      parts.push(`${wholeInWords(Math.floor(n / size))} ${name}`);
      n %= size;
    }
  });
  if (n) parts.push(belowThousand(n));
  return parts.join(" ");
};
export const amountInWords = (amount) => {
  const value = Math.round(Number(amount) * 100) / 100;
  if (!Number.isFinite(value) || value <= 0) return "";
  const rupees = Math.floor(value);
  const paise = Math.round((value - rupees) * 100);
  return `Rupees ${wholeInWords(rupees)}${paise ? ` and ${belowHundred(paise)} Paise` : ""} Only`;
};
